export const ALLOWED_FILE_TYPES = [
  "pdf",
  "doc",
  "docx",
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "svg",
  "txt",
  "csv",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "json",
  "zip",
  "rar",
  "mpp",
  "mpt",
  "dwg",
  "dwf",
  "dxf",
];

export const getMimeTypes = (extensions: string[]): string[] => {
  const mimeMap: Record<string, string> = {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    svg: "image/svg+xml",
    txt: "text/plain",
    csv: "text/csv",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    json: "application/json",
    zip: "application/zip",
    rar: "application/x-rar-compressed",
    mpp: "application/vnd.ms-project",
    mpt: "application/vnd.ms-project",
    dwg: "image/vnd.dwg",
    dxf: "image/vnd.dxf",
    dwf: "model/vnd.dwf",
  };

  if (extensions.includes("*")) {
    return ["*/*"];
  }

  return extensions
    .map((ext) => mimeMap[ext.toLowerCase()])
    .filter((mime): mime is string => Boolean(mime));
};
